export default "__VITE_ASSET__20bd3792__"